import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AppModeService } from '../../../angular-wallet-base/services/app-mode.service';
@Component({
  selector: 'tos',
  templateUrl: 'tos.page.html',
  styleUrls: ['tos.page.scss']
})
export class TosPage implements OnInit {

  readonly type: string;
  public isDesktopMode;
  public enableAgreeButton: boolean = false;
  @ViewChild('tosContainerMobile', { static: true }) tosMobile;
  @ViewChild('tosContainerDesktop', { static: true }) tosDesktop;

  constructor(private route: ActivatedRoute,
              private appMode: AppModeService,
              private nav: NavController) {
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
    this.type = this.route.snapshot.params['type'] ? this.route.snapshot.params['type'] : 'new';
  }

  ngOnInit() {
    this.tosMobile.nativeElement.onscroll = (e) => {         
      const tosEl = e.target;
      const scrollTop = tosEl.scrollTop;
      const offSetHeight = tosEl.offsetHeight;
      const scrollHeight = tosEl.scrollHeight;
      
      if(scrollTop === 0){
        this.enableAgreeButton=false;
      }
      if(scrollTop>scrollHeight-offSetHeight-1){
        this.enableAgreeButton=true;
      }
    };

    this.tosDesktop.nativeElement.onscroll = (e) => {
      const tosEl = e.target;
      const scrollTop = tosEl.scrollTop;
      const offSetHeight = tosEl.offsetHeight;
      const scrollHeight = tosEl.scrollHeight;
      
      if(scrollTop === 0){
        this.enableAgreeButton=false;
      }
      if(scrollTop>scrollHeight-offSetHeight-1){
        this.enableAgreeButton=true;
      }
    };
  }

  continueSetup() {
    switch (this.type) {
      case 'new':
        return this.nav.navigateForward('/setup/setup-pin/new');
      case 'recover':
        return this.nav.navigateForward('/setup/setup-pin/recover');
      default:
        return this.nav.navigateForward('/setup/setup-pin/new');
    }
  }

}
